/**
 * 讓 antd Table 的排序表頭能用鍵盤操作。
 *
 * antd 4 的 `useSorter` 只在 `onHeaderCell` 掛 `onClick`，`rc-table` 的表頭儲存格也不會
 * 產生 `tabIndex` 或 `onKeyDown` —— 於是排序對鍵盤使用者完全不存在 (WCAG 2.1.1 Keyboard)。
 * 實際後果是：Tab 進表格時焦點只停得住儲存格內的可聚焦元素，表頭永遠被跳過，
 * 「哪個房型的 RevPAR 最低」這種只能靠排序回答的問題就做不到了。
 *
 * `useSorter` 會先取用自訂 `onHeaderCell` 的回傳值，再覆寫 `onClick` 並在內部保留原本的
 * handler，所以這裡加的 `tabIndex` / `onKeyDown` 會存活下來，`click()` 也會正確觸發排序。
 */

/** 單一欄位的表頭鍵盤支援；`base` 是該欄原本的 onHeaderCell (若有)。 */
export function keyboardSortHeader(base) {
  return (col) => ({
    ...(typeof base === 'function' ? base(col) : {}),
    tabIndex: 0,
    onKeyDown: (e) => {
      // 只認 Enter 與空白：方向鍵在表格裡另有捲動語意，攔下來反而擋掉使用者的操作
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        if (e.currentTarget && e.currentTarget.click) e.currentTarget.click();
      }
    },
  });
}

/**
 * 把鍵盤支援套到所有「有 sorter」的欄位上。沒有 sorter 的表頭按下去不會發生任何事，
 * 給它焦點只會讓 Tab 序多幾站空白。
 *
 * 會遞迴處理 `children` —— 多層表頭 (如本期/對比期分組) 的 sorter 掛在葉節點上。
 */
export function withKeyboardSort(columns) {
  return (columns || []).map((c) => {
    const next = c.children ? { ...c, children: withKeyboardSort(c.children) } : { ...c };
    return next.sorter ? { ...next, onHeaderCell: keyboardSortHeader(c.onHeaderCell) } : next;
  });
}
